import { Fragment } from 'react';
import Image from 'next/legacy/image';

import {
  CategoryMenuCategories,
  Categories2,
  SideBarPosts,
  SideBarPostData,
} from '@components';
import { Banner } from '@api';
import { lpUrl1 } from '@constants';
import HnaviBanner2 from '@images/hnavi-banner-2.jpg';
import OyakudachiBanner from '@images/oyakudachi-banner.jpg';
import { categoryPath, developerEntryPath } from '@paths';

export const SideContents: React.FC<{
  latestPosts?: SideBarPostData[];
  popularPosts?: SideBarPostData[];
  postGroups?: {
    groupName: string;
    showIndex?: boolean;
    posts?: (SideBarPostData | undefined | null)[] | null; // TODO
  }[];
  categories?: CategoryMenuCategories;
  stickyBanner?: Banner | null;
  fixedBanner?: Banner | null;
  offsetStickyBannerForStickyTitleBar?: boolean;
}> = ({
  latestPosts,
  popularPosts,
  categories,
  postGroups,
  fixedBanner,
  stickyBanner,
  offsetStickyBannerForStickyTitleBar,
}) => {
  return (
    <>
      <a
        href={fixedBanner?.href || lpUrl1}
        className='mx-auto mb-3 block max-w-[270px]'
      >
        <Image
          src={fixedBanner?.imgSrc || HnaviBanner2}
          layout='responsive'
          height={fixedBanner?.imgHeight || 270}
          width={fixedBanner?.imgWidth || 270}
          sizes='270px'
          objectFit='contain'
          alt={fixedBanner?.imgAlt || 'バナー画像'}
        />
      </a>
      {categories && (
        <span className='block w-full bg-lightgray p-5'>
          <h3 className='bottom-1 border-b border-secondary pb-4 font-bold'>
            カテゴリー
          </h3>
          <Categories2 categories={categories} />
        </span>
      )}
      {popularPosts && (
        <>
          <h3 className='bottom-1 border-b-2 border-black py-4 font-bold'>
            ランキング
          </h3>
          <SideBarPosts showIndex posts={popularPosts} />
        </>
      )}
      {latestPosts && (
        <>
          <h3 className='bottom-1 border-b-2 border-black py-4 font-bold'>
            新着記事
          </h3>
          <SideBarPosts posts={latestPosts} />
        </>
      )}
      {postGroups
        ?.filter((g) => !!g.posts?.length)
        .map((g) => (
          <Fragment key={g.groupName}>
            <h3 className='bottom-1 border-b-2 border-black py-4 font-bold'>
              {g.groupName}
            </h3>
            <SideBarPosts showIndex={g.showIndex} posts={g.posts} />
          </Fragment>
        ))}
      {stickyBanner && stickyBanner.href && stickyBanner.imgSrc && (
        <div
          className={`sticky ${
            offsetStickyBannerForStickyTitleBar ? 'top-32' : 'top-8'
          } mx-auto mb-8 max-w-[270px] lg:mb-16`}
        >
          <a href={stickyBanner.href} className='block'>
            <Image
              src={stickyBanner.imgSrc}
              height={stickyBanner.imgHeight || 270}
              width={stickyBanner.imgWidth || 270}
              sizes='270px'
              objectFit='contain'
              alt={stickyBanner.imgAlt || 'バナー画像'}
            />
          </a>
          <a
            href={categoryPath('books?argument=bzcUT99h&dmai=a67c5b4345ed7e')}
            className='mt-4 block'
          >
            <Image
              src={OyakudachiBanner}
              sizes='270px'
              objectFit='contain'
              alt='即実践!DX成功のカギ お役立ち資料 資料一覧はこちら'
            />
          </a>
          <a
            href={`${developerEntryPath}?argument=bzcUT99h&dmai=a68da7c14ad7d5`}
            className='mt-4 flex items-center justify-center rounded-full border border-gray px-6 py-3 font-bold text-gray transition hover:border-secondary hover:text-secondary'
          >
            案件を受けたい開発会社はこちら
          </a>
        </div>
      )}
    </>
  );
};
